<template>
  <div>
    <button
        @click="showModal(row.id)"
        class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
      <span class="tooltip-text">جزئیات</span>
      <i class="fas fa-eye"></i>
    </button>
    <UpdateFieldModal :datatable="datatable" :field="row" />
    <a v-if="$can('change-setting', 'payment-link')" type="button" @click="delete_customer(row)" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
      <span class="tooltip-text">{{ $t('online-factor.erase') }}</span>
      <i class="fas fa-trash"></i>
    </a>
  </div>
</template>
<script>

import Vue from "vue";
import { onlineFactorService } from '@/common/api.service'
import toastr from "toastr";
import Button from "@/components/elements/button.vue";
import UpdateFieldModal from "@/views/online-factor/UpdateFieldModal.vue";
import $ from 'jquery'

export default Vue.extend({
  components: {UpdateFieldModal, Button},
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    }
  },
  computed : {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: true,
        rtl: false
      }

      return toastr
    }
  },
  methods:{
    showModal(id) {
      $(`#update_field_${id}`).modal('show')
    },
    delete_customer() {
      onlineFactorService.adminDeleteField(this.row.id)
          .then(response => {
            this.datatable.reload()
            return this.toastr.success(response.data.message)
          })
          .catch(({response}) => {
            return this.toastr.error(response.data.message)
          })
    }
  },
})

</script>


<style>
.special-tooltip{
  position: relative;
  display: inline-block;
}
.special-tooltip .tooltip-text {
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  opacity: 0;
  transition: opacity 0.3s;
  min-width: 90px !important;
}
.special-tooltip .tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  /*margin-left: -5px;*/
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
.special-tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
